import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

import heroImage from "../assets/hero.png";
import smallImage from "../assets/small-image.png";

export const DaisyHero = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  return (
    <div>
      {/* Desktop hero */}
      <div
        className="hidden md:flex flex-col justify-center items-center min-h-screen relative"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-stone-900/55" />
        <div className="relative z-10 text-center text-white px-4 max-w-2xl mx-auto">
          <p className="text-xs tracking-[0.3em] uppercase text-gold-light mb-6 font-light">
            {language === "pt" ? "Joias artesanais" : "Handcrafted Jewelry"}
          </p>
          <h1 className="font-display text-7xl mb-8 leading-tight">
            {language === "pt"
              ? "Criações de todo o mundo."
              : "Creations from around the world."}
          </h1>
          <p className="text-stone-300 text-sm leading-relaxed mb-12 max-w-lg mx-auto font-light">
            {language === "pt"
              ? "Inspiradas por amantes de joias e mulheres maravilhosas, a nossa paixão é criar joias preciosas e atemporais tão belas e individuais quanto as pessoas que as usam. Acreditamos que o luxo nunca deve ser exagerado ou intimidante, mas divertido, natural e fácil de usar."
              : "Inspired by jewelry lovers and wonderful women, our passion is to design precious, timeless jewelry that is as beautiful and individual as the people who wear it. We believe that luxury should never be over the top or intimidating, but fun, natural and easy to wear."}
          </p>
          <button
            onClick={() => navigate("/Collections")}
            className="border border-gold text-gold hover:bg-gold hover:text-white transition-all duration-300 text-xs tracking-[0.2em] uppercase px-12 py-4"
          >
            {language === "pt"
              ? "Ver as nossas coleções"
              : "See our collections"}
          </button>
        </div>
      </div>

      {/* Mobile hero */}
      <div className="md:hidden flex flex-col items-center justify-center px-6 py-16 bg-cream">
        <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5 font-light">
          {language === "pt" ? "Joias artesanais" : "Handcrafted Jewelry"}
        </p>
        <h1 className="font-display text-5xl text-center mb-8 leading-snug text-stone-800">
          {language === "pt"
            ? "Criações de todo o mundo."
            : "Creations from around the world."}
        </h1>
        <div className="w-full mb-8 overflow-hidden shadow-lg">
          <img
            src={smallImage}
            alt={language === "pt" ? "Decorativo" : "Decorative"}
            className="w-full object-cover"
          />
        </div>
        <p className="text-stone-500 text-sm leading-relaxed text-center mb-10 font-light">
          {language === "pt"
            ? "Inspiradas por amantes de joias e mulheres maravilhosas, a nossa paixão é criar joias preciosas e atemporais."
            : "Inspired by jewelry lovers and wonderful women, our passion is to design precious, timeless jewelry."}
        </p>
        <button
          onClick={() => navigate("/Collections")}
          className="border border-gold text-gold hover:bg-gold hover:text-white transition-all duration-300 text-xs tracking-[0.2em] uppercase px-12 py-4"
        >
          {language === "pt" ? "Ver as nossas coleções" : "See our collections"}
        </button>
      </div>
    </div>
  );
};

export default DaisyHero;
